import * as Routes from 'constants/Routes'

export default () => ({
  path: Routes.NOT_FOUND,
  getComponent: async function (nextState, cb) {
    const module = await import('./components/NotFoundView')
    cb(null, module.default)
  }
})
